import React from "react";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import rightImg from "images/about-hero-right.png";
import SectionHero from "components/SectionHero/SectionHero";
import Layout from "../../(others)/layout";
import "../../../styles/styles.css"

const PageMission = () => {
  return (
    <Layout>
        <div className="dark bg-neutral-900/95 py-4 lg:py-7 space-y-4 lg:space-y-7">
          <div className="relative">
          <div className={`nc-SectionHero relative`}>

            <div className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 lg:space-x-10 items-center relative text-center lg:text-left">
              <div className="w-screen max-w-full xl:max-w-lg space-y-5 lg:space-y-7">
                <h2 className="inline-block align-middle text-4xl font-semibold md:text-5xl">
                  Mission
                </h2>
                <span className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
                Pouvoir démontrer vos produits et services dans leurs plus beaux atouts, sous leurs meilleurs angles à travers une vidéo aérienne peut s'avérer très avantageux.
                <br></br>
                Comme notre nom l'indique, nous croyons que c'est la capacité d'avoir une vision du message à envoyer qui nous définit.
                <br></br>
                Pour ce faire, l'équipe VISIONNAIREDRONE prend le temps de bien écouter et comprendre vos besoins et aspirations afin de travailler ensemble à mettre en avant-plan vos meilleurs atouts de ventes.
                </span>
              </div>
              <div className="flex-grow">
                <div className="w-full">
                    <table>
                      <tbody></tbody>
                      <tr>
                        <td>
                          <img className="arrondie" src="../../images/Mission1.jpg" />
                        </td>
                        <td>
                          <img className="arrondie" src="../../images/Mission2.jpg" />
                        </td>
                        <td>
                          <img className="arrondie" src="../../images/Mission3.jpg" />
                        </td>
                        <td>
                          <img className="arrondie" src="../../images/Mission4.jpg" />
                        </td>
                        <td>
                          <img className="arrondie" src="../../images/Mission5.jpg" />
                        </td>
                      </tr>
                    </table>
                </div>
              </div>
            </div>
            </div>
          </div>
      </div>
    </Layout>
  );
};

export default PageMission;
